module.exports = __webpack_public_path__ + "img/gift1.b76e4432.png";